import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '@/features/auth/services/authService';
import { clearRememberMe } from '@/features/auth/utils/rememberMeStorage';
import { apiService } from '@/services/apiService';
import { playClickSound } from '@/utils/soundUtils';

/**
 * Shared logout flow for the header account menu.
 * account menu and the footer trust strip use the exact same logic.
 */
export function useLogout() {
  const navigate = useNavigate();

  return useCallback(async () => {
    playClickSound();
    try {
      await authService.logout();
    } catch (error) {
      console.error('Error during logout:', error);
    }
    // Guarantee: clear token, clear remember, clear cache, then go home
    apiService.clearTokens();
    apiService.clearUserCache();
    clearRememberMe();
    navigate('/', { replace: true });
  }, [navigate]);
}

export default useLogout;
